module.exports = __webpack_public_path__ + "static/media/team_12.566edc2b.jpg";